"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveUsersPage = void 0;
const React = __importStar(require("react"));
const ActiveUsersPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/activeUsers/ActiveUsersPageModelProvider");
const ActiveUsersPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/activeUsers/ActiveUsersPageDataProvider");
const ActiveUsersDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/activeUsers/ActiveUsersDataProvider");
const react_1 = require("react");
const DataState_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/activeUsers/state/data/DataState");
const ActiveUsersPage = () => {
    (0, react_1.useEffect)(() => {
        setTimeout(() => window.scrollTo({ top: 0 }), 0);
    }, []);
    return React.createElement(ActiveUsersDataProvider_1.ActiveUsersDataProvider, null,
        React.createElement(ActiveUsersPageModelProvider_1.ActiveUsersPageModelProvider, null,
            React.createElement(ActiveUsersPageDataProvider_1.ActiveUsersPageDataProvider, null,
                React.createElement(DataState_1.DataState, null))));
};
exports.ActiveUsersPage = ActiveUsersPage;
